import "javascript/src/users/oauth/facebook";
import "javascript/src/users/oauth/google";
import url from 'javascript/src/utils/url';
import I18n from 'javascript/i18n-js/index.js.erb';
const PASSWORD_MIN_CHAR=6; //do better ! take it from devise setup
function isPath(path){ return window.location.pathname.match(path); }
function isSignIn(){ return isPath("/users/sign_in"); }
function isSignUp(){ return isPath("/users/sign_up"); }
function isRescue(){ return isPath(/\/users\/(password|confirmation)[a-z\/]*/); }

function execSetMode(){
  if(isSignIn())signInMode();
  else if (isSignUp())signUpMode();
  else if (isRescue())rescueMode();
}

function rescueMode(){
  url.removeParam("confirmation_token");
  document.querySelector("#linkModeSignUp").classList.remove("loginSelectLink");
  document.querySelector("#linkModeSignIn").classList.remove("loginSelectLink");
  document.querySelector("#new_user").setAttribute('action', "/users/password");
  window.history.pushState({}, null, window.location.href.replace(window.location.pathname,"/users/password/new"));
  document.querySelectorAll(".modeSignIn").forEach((e, i) => {
    e.classList.remove("open"); });
  document.querySelectorAll(".modeSignUp").forEach((e, i) => {
    e.classList.remove("open"); });

  document.querySelector("[type=submit]").textContent = I18n.t('user.loginup.instruction_by_mail');
}

function signInMode(){
  document.querySelector("#linkModeSignIn").classList.add("loginSelectLink");
  document.querySelector("#linkModeSignUp").classList.remove("loginSelectLink");
  document.querySelector("#new_user").setAttribute('action', "/users/sign_in");
  window.history.pushState({}, null, window.location.href.replace(window.location.pathname,"/users/sign_in"));
  document.querySelectorAll(".modeSignUp").forEach((e, i) => {
    e.classList.remove("open");});
  document.querySelectorAll(".modeSignIn").forEach((e, i) => {
    e.classList.add("open");});
  document.querySelector("[type=submit]").textContent = I18n.t('user.loginup.login');
}

function signUpMode(){
  document.querySelector("#linkModeSignIn").classList.remove("loginSelectLink");
  document.querySelector("#linkModeSignUp").classList.add("loginSelectLink");
  document.querySelector("#new_user").setAttribute('action', "/users");
  window.history.pushState({}, null, window.location.href.replace(window.location.pathname,"/users/sign_up"))
  document.querySelectorAll(".modeSignIn").forEach((e, i) => {
    e.classList.remove("open");});
  document.querySelectorAll(".modeSignUp").forEach((e, i) => {
    e.classList.add("open");});

  document.querySelector("[type=submit]").textContent = I18n.t('user.loginup.signup');
}

function changeMode(){ if(!isSignIn())signInMode(); else signUpMode();}
function setMode(){ execSetMode(); }
document.addEventListener('turbolinks:load',function() {
  document.querySelectorAll(".loginModeLink").forEach((item, i) => {
    item.addEventListener('click',changeMode)})});
document.addEventListener('turbolinks:load',function() {setMode()});
document.addEventListener('turbolinks:load',function() {document.querySelector("#rescueMode").addEventListener('click',rescueMode)})

function validateAndConnect(me){
  let mdp = document.querySelector("#user_password").value;
  let email = document.querySelector("#user_email")[0];

  //valid email
  if(email.value == ""){ M.toast({html: I18n.t('user.loginup.need_email')}); return; }
  if(!email.validity.valid){ M.toast({html: email.validationMessage}); return; }

  //valid mdp
  if(!isRescue()){
    if(mdp == ""){ M.toast({html: I18n.t('user.loginup.empty_pass')}); return; }
    if(mdp.length < 6){
      M.toast({html: I18n.t('user.loginup.password_min_size',{n: PASSWORD_MIN_CHAR})}); return; }
    if(!isSignIn() && mdp != document.querySelector("#user_password_confirmation").value){
      M.toast({html: I18n.t('user.loginup.password_differ')}); return; }
  }
  document.querySelector("form").submit();
}
document.addEventListener('turbolinks:load', function() {document.querySelector("[type=submit]").addEventListener('click',validateAndConnect)});
